// src/internal/components/navigation/navigation-item.tsx
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import { jsx } from "react/jsx-runtime";
var NavigationItem = (props) => {
  const { children, ...rest } = props;
  return /* @__PURE__ */ jsx(Tab, { label: children, "aria-current": props.selected && "page", ...rest });
};
var ButtonItem = styled(Link)(() => ({
  alignSelf: "center",
  textAlign: "center"
}));
var navigation_item_default = NavigationItem;

export {
  ButtonItem,
  navigation_item_default
};
